import React, { forwardRef, useEffect, useRef, useState } from 'react';
// Keep the native input accessible; the visual overlay never duplicates its spoken value.
const EditorSingleLineInput = forwardRef(function EditorSingleLineInput(
  { focusAtEnd = false, value, placeholder, className = '', onFocus, onBlur, ...props },
  ref,
) {
  const [focused, setFocused] = useState(false);
  const timer = useRef(null);
  const clear = () => {
    clearTimeout(timer.current);
    timer.current = null;
  };
  useEffect(() => clear, []);
  return (
    <div className={`pp-editor-single-line ${focused ? 'is-focused' : ''} ${className}`}>
      <input
        {...props}
        ref={ref}
        value={value}
        placeholder={placeholder}
        onFocus={(event) => {
          setFocused(true);
          clear();
          const input = event.currentTarget;
          if (focusAtEnd)
            timer.current = setTimeout(() => {
              if (document.activeElement === input)
                input.setSelectionRange(input.value.length, input.value.length);
            }, 0);
          onFocus?.(event);
        }}
        onBlur={(event) => {
          clear();
          setFocused(false);
          onBlur?.(event);
        }}
      />
      {!focused && (
        <span
          aria-hidden="true"
          className={`pp-editor-input-display${value ? '' : ' is-placeholder'}`}
        >
          {value || placeholder}
        </span>
      )}
    </div>
  );
});
export default EditorSingleLineInput;
